/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Badge , Button , Card , Row , Col,ProgressBar} from 'react-bootstrap'
import Constants from '../constants.js';
import AccountService from '../services/account-service.js';
import UserService from '../services/user-service.js';
import ClassesService from '../services/classes-service.js';
import AccountStore from '../store/account-store.js';
import ProductStore from '../store/product-store.js';
import ProductService from '../services/product-service.js';
import Translation from '../store/internationalization-store.js';
import Table from '../components/general_table.js'
import NewStaffMember from '../components/popup/new_staff.js';
import Popup from '../components/popup/staff_edit_multiple_popup.js';
import Comfirmation from '../components/popup/comfirmation_popup.js';
import ClassesStore from '../store/classes-store.js';

export default class Authentication extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.displayLimit = 5;

        this.state = {
            data:AccountStore.staff || [],
            addClasses:false,
            classList:[],
            selectedClassList:[],
            loading:false
        };
    }

    componentDidMount(){
        ClassesService.getMine()
        AccountService.getMembers()
        ProductService.getUserData();
    }

    componentWillMount(){
        AccountStore.on(Constants.GET_ACCOUNT_STAFF , ()=>{
            this.setState({
                data:AccountStore.staff || [],
                loading:false
            })
        });

        ClassesStore.on(Constants.GET_MY_CLASSES , ()=>{
            this.setState({
                classList:ClassesStore.getList(),
            })
        })

        ProductStore.on(Constants.GET_USER_DATA,  ()=>{
            var userData = ProductStore.getUserData();
            if (userData.userType == "admin" || userData.userType == "school") {
                this.setState({type:"admin"});
            } else {
                this.setState({type:"teacher"});
            }
        });
    }

    classes(cell , row){

        let c = [];

        for(var i = 0 ; i < cell.length; i++)
        {
            c.push(<Badge style={{marginLeft:'5px'}}variant="primary" >&nbsp;{cell[i].name}&nbsp;</Badge>)
        }

        return c
    }

    getList(){

    }

    updateStaff(){
        this.setState({loading:true});
        AccountService.getMembers()
    }

    deleteObject(){
        UserService.deleteStaff(this.state.deletedTeacher).then(function(){
            this.updateStaff();
            this.setState({showDelete:false});
        }.bind(this))
    }

    closeDeleted(){
        this.setState({showDelete:false});
    }



    render(){

        if(this.state.loading) return <ProgressBar animated now={45} />

        const columns = [
            {
                dataField: 'name',
                text: Translation.get(14 , 'Name'),
                sort: true,
                align: "left",
                formatter:(cell , row)=>{
                    return <a class="hyperlink" onClick={()=>{ this.setState({addClasses:true ,selectedClassList:row.classes , selectedUID:row.uid , selected:row })}}>{cell}</a>
                }
            },
            {
                dataField: 'email',
                text: Translation.get(9 , 'Email'),
                sort: true,
                align: "left",
            },
            {
                dataField: 'user_type',
                text: Translation.get(2013 , 'Type'),
                sort: true,
                align: "left",
                formatter:(cell)=>{
                    switch(cell){
                        case 'school_teacher': return Translation.get(4 , 'Teacher');
                        case 'teacher': return Translation.get(4, 'Teacher');
                        case 'school' : return Translation.get(12663 , 'Admin');
                        case 'admin' : return Translation.get(12663 , 'Admin');
                        default: return Translation.get(12756 , 'Unknown');
                    }
                }
            },
            {
                dataField: 'classes',
                text: Translation.get(830 , 'Classes'),
                sort: true,
                align: "left",
                formatter:this.classes,
                csvFormatter:(cell , row)=>{
                    var data = "";
                    for (var i = 0; i < cell.length; i++) {
                        data += cell[i].name;
                        data += ", ";
                    }
                    return data;
                },
                headerStyle: {
                    width: '50%'
                },
                style: {
                    width: '50%'
                }
            },

        ];

        if (this.state.type == "admin") {
            columns.push({
                dataField: 'delete',
                text:  '',
                csvExport: false,
                formatter: (cell, row)=>{
                    return <div onClick={function() {
                        this.setState({showDelete:true, deletedTeacher:row.uid});
                    }.bind(this)}><i class="fas fa-trash-alt"></i></div>;
                }
            })
        }


        const options = {
            sizePerPage: 15,
            hideSizePerPage: true,
            hidePageListOnlyOnePage: true
        };

        let allClasses = this.state.classList.map(function(object , index){
            return {label:object.name ,value: object.uid};
        }.bind(this));

        let selectedClasses = this.state.selectedClassList.map(function(object , index){
            return {label:object.name ,value: object.uid};
        }.bind(this));

        return <div >
                <Comfirmation body={Translation.get(0 , 'Are you sure you wish to delete this teacher?')} 
                        onSave={this.deleteObject.bind(this)} show={this.state.showDelete} 
                        onHide={this.closeDeleted.bind(this)}/> 
                <Popup selected={this.state.selected} show={this.state.addClasses} value={selectedClasses || []} onSave={this.updateStaff.bind(this)} data={allClasses} title={Translation.get(12600, 'Edit Teacher Access')} fieldTitle="Select Teachers" onHide={ ()=>{ this.setState({addClasses:false})}}></Popup>
                <Row>
                    <Col md={12}>
                        <Card body >
                            <NewStaffMember show={this.state.show} onHide={()=>{AccountService.getMembers(); this.setState({show:false})}} />
                            <Table component={ <div style={{paddingBottom:".5rem"}}><Button onClick={()=>{this.setState({show:true})}} >{Translation.get(12757 , 'Add Staff')}</Button></div>}  bordered={ true } keyField='uid' data={ this.state.data ||  [] } columns={ columns } />
                        </Card>
                    </Col>
                </Row>
        </div>
    }


}